import type { MoveCopyAttachCrossAccountDialogStore } from './schema/MoveCopyAttachCrossAccountDialogStore';
import { createStore } from 'owa-satcheljs';

export const getStore: () => MoveCopyAttachCrossAccountDialogStore =
    createStore<MoveCopyAttachCrossAccountDialogStore>('moveCopyAttachCrossAccountDialogStore', {
        isShown: false,
        title: undefined,
        message: undefined,
        isCrossAccountNotAllowed: false,
        sourceMailboxInfo: undefined,
        destinationMailboxInfo: undefined,
        globalSettingsMailboxInfo: undefined,
        onDialogResponse: undefined,
        type: undefined,
        projectionTabId: undefined,
    });
export default getStore;
